import React from 'react';
import { motion } from 'framer-motion';
import { Gem, Circle, Flower2, Sparkles, Clock, Quote } from 'lucide-react';
import { useTranslation } from '../i18n/LanguageContext';
export function FerbyTouchSection() {
  const {
    t
  } = useTranslation();
  const icons = [<Gem className="w-8 h-8 text-lavender-500" key="g" data-id="element-150" />, <Circle className="w-8 h-8 text-cream-500 fill-cream-100" key="c" data-id="element-151" />, <Flower2 className="w-8 h-8 text-blush-500" key="f" data-id="element-152" />, <Sparkles className="w-8 h-8 text-gold-500" key="s" data-id="element-153" />, <Clock className="w-8 h-8 text-lavender-600" key="cl" data-id="element-154" />];
  const processes = t.ferbyTouch.processes.map((p, i) => ({
    ...p,
    icon: icons[i]
  }));
  return <section id="ferbytouch" className="py-24 bg-white relative overflow-hidden" data-id="element-155">
      <div className="absolute top-0 right-0 w-64 h-64 bg-lavender-50 rounded-full blur-3xl -z-10 opacity-50 translate-x-1/2 -translate-y-1/2" data-id="element-156"></div>
      <div className="absolute bottom-0 left-0 w-80 h-80 bg-blush-50 rounded-full blur-3xl -z-10 opacity-50 -translate-x-1/2 translate-y-1/2" data-id="element-157"></div>

      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-158">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-159">
          <h2 className="font-serif text-4xl md:text-5xl text-gray-900 mb-4 inline-block relative" data-id="element-160">
            {t.ferbyTouch.heading}
            <svg className="absolute w-full h-3 -bottom-2 left-0 text-lavender-300" viewBox="0 0 200 9" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-161">
              <path d="M2.00025 6.99999C43.5003 1.99999 123.5 -2.00001 198 6.99999" stroke="currentColor" strokeWidth="3" strokeLinecap="round" data-id="element-162" />
            </svg>
          </h2>
          <p className="text-xl text-gray-600 mt-8 max-w-2xl mx-auto" data-id="element-163">
            {t.ferbyTouch.intro}
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-20" data-id="element-164">
          {processes.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-cream-50 rounded-2xl p-8 border border-lavender-100 hover:shadow-lg transition-all hover:-translate-y-1 flex flex-col items-center text-center group" data-id="element-165">
              <div className="w-16 h-16 rounded-full bg-white flex items-center justify-center shadow-sm mb-6 group-hover:scale-110 transition-transform duration-300" data-id="element-166">
                {item.icon}
              </div>
              <h3 className="font-serif text-xl font-semibold text-gray-900 mb-3" data-id="element-167">
                {item.title}
              </h3>
              <p className="text-gray-600" data-id="element-168">{item.desc}</p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="max-w-3xl mx-auto text-center" data-id="element-169">
          <p className="text-lg text-gray-600 mb-8" data-id="element-170">
            {t.ferbyTouch.conclusion}
          </p>
          <div className="relative inline-block" data-id="element-171">
            <Quote className="absolute -top-6 -left-8 w-10 h-10 text-lavender-200 rotate-180" data-id="element-172" />
            <p className="font-serif italic text-3xl md:text-4xl text-lavender-700 relative z-10 px-4" data-id="element-173">
              {t.ferbyTouch.quote}
            </p>
            <Quote className="absolute -bottom-6 -right-8 w-10 h-10 text-lavender-200" data-id="element-174" />
          </div>
        </motion.div>
      </div>
    </section>;
}